// Engineers' exposure by task (R1-10, decided by Dr. Tatar 2026-10-24).
// Engineer battalions do not hold frontage and do not fight unless they must; their casualty modifier is a share of the
// infantry rate that depends on what the brigade is doing that day. It replaces the flat battalion modifier (0.8) for
// ENGINEERS battalions when ENGINEER_TASK_EXPOSURE_ON is true. No manual override in Tab 2: the factor follows the phase.
//
// status: EDUCATED_GUESS (levels rounded from two WWII/Alamein points, see docs/research/RESEARCH_ENGINEERS.md)
//   ORDINARY  0.10  defense, retrograde, reserve, security, stability, march: WWII US officers, engineers about 0.1 of infantry
//   ATTACK    0.20  attack-family phases: working near the line (gaps, roads, bridges) while the infantry fights; no data
//   ASSAULT   0.50  first day of the phase under an assault condition (breach, river crossing, urban, fortified, amphibious):
//                   Second Alamein minefield breach, engineer officers about 0.55 of infantry (one 12-day battle, secondary)
export const ENGINEER_EXPOSURE_LEVELS = Object.freeze({
  ORDINARY: 0.10,
  ATTACK: 0.20,
  ASSAULT_FIRST_DAY: 0.50
});

export const ENGINEER_ASSAULT_CONDITIONS = Object.freeze(['BREACH', 'RIVER_ASSAULT', 'URBAN', 'FORTIFIED_ASSAULT', 'AMPHIBIOUS']);

/**
 * @param {{family: string|null, condition: string|null, dayInPhase: number}} p  family = PHASE_FORMS[form].family
 * @returns {number} engineer casualty modifier (share of the infantry rate)
 */
export function engineerExposure({ family, condition, dayInPhase }) {
  if (family === undefined || family === null) {
    throw new Error('engineerExposure: phase family is required');
  }
  if (family === 'ATTACK') {
    return (ENGINEER_ASSAULT_CONDITIONS.includes(condition) && dayInPhase <= 1)
      ? ENGINEER_EXPOSURE_LEVELS.ASSAULT_FIRST_DAY
      : ENGINEER_EXPOSURE_LEVELS.ATTACK;
  }
  return ENGINEER_EXPOSURE_LEVELS.ORDINARY;
}
